import axios from "axios";
import moment from "moment";
import { BASE_URL } from "../../../consts/app.consts";

const ResourcePersonReportv2 = {
    searchApi: "xceed.api.report.resource_person.get_resource_person_report_v2",
    excelFileName: "student-enrolment-and-summary-report",
    title: "Resource Persons by Subject Areas Report",
    extraActionsAsMenu: true,
    sections: [
        {
            selectionTitle: "Filters",
            grid: { base: 1, md: 2, lg: 4, xl: 4 },
            filters: [
                {
                    label: "Subject Areas",
                    type: "form-select",
                    key: "subject_area",
                    isMulti: true,
                    optionMethod: "xceed.api.report.resource_person.get_subject_areas",
                }
            ],
        }
    ],

    tableConfig: {
        column: [
            {
                header: "Full Name",
                accessor: "full_name",
                width: 300,
                // customRenderer: (value: any, item: any) => {
                //     if (value == 0) return value
                //     const id = get(item, "name", "");
                //     const link = `/app/resource-person/${id}`;

                //     return React.createElement(DefaultCellV2, { navigateTo: link, value });
                // },
            },
            {
                header: "Designation",
                accessor: "designation",
                width: 300,
            },
            {
                header: "Workplace",
                accessor: "workplace",
                width: 300,
            },
            {
                header: "Mobile Number",
                accessor: "mobile_number",
                width: 300,
            },

            {
                header: "Email",
                accessor: "email_address",
                width: 300,
            }
        ],
    },
    actions: [
        {
            text: "Export to excel",
            onClick: async (filter: any, data: any, setLoading: any) => {

                setLoading(true)
                try {
                    let response = await axios.post(`${BASE_URL}/method/xceed.api.export_excel.resource_person.export_resource_person_report_v2`, { filter }, {
                        withCredentials: true,
                        responseType: "blob"
                    })
                    if (response) {
                        console.log(response)
                        const href = URL.createObjectURL(response.data);

                        const link = document.createElement('a');
                        link.href = href;
                        link.setAttribute('download', `resource-persons-by-subject-areas-report-${moment().format('YYYY-MM-DD')}.xlsx`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(href);
                    }
                    setLoading(false)

                } catch (error: any) {
                    setLoading(false)
                    const newError: any = new Error('Unable to Generate Excel file');
                    newError.title = 'Error';
                    newError.status = 'error';
                    throw newError
                }
            },
            buttonVariant: "solid",
            buttonColorScheme: "teal"
        },
    ],
};

export default ResourcePersonReportv2;